<template>
  <div class="com-cart-add b_white">
    <van-form label-width="85px" label-align="right" @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          maxlength="10"
          v-model="form.name"
          name="自提人姓名"
          label="自提人姓名:"
          placeholder="请输入自提人姓名"
          :rules="[{ required: true, message: '请输入自提人姓名' }]"
        />
        <van-field
          type="tel"
          maxlength="11"
          v-model="form.tel"
          name="phoneNum"
          label="手机号:"
          placeholder="请输入自提人手机号"
          :rules="[
            { required: true, message: '请输入自提人手机号' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }
          ]"
        />
      </van-cell-group>
      <div class="add-bottom">
        <van-button round block type="primary" native-type="submit">
          保存
        </van-button>
        <div class="footer_iphone"></div>
      </div>
    </van-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { Toast } from "vant";

export default {
  data() {
    // const phoneNum = val => val.length === 11;
    return {
      form: {
        name: "",
        tel: "",
        cusBoId: "",
        validateCust: "",
        cusId: ""
      }
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { id, tel, name } = this.$route.query;
    document.title = id ? "修改自提人" : "新增自提人";
    if (this.$route.query.cusBoId) {
      this.form.cusBoId = this.$route.query.cusBoId;
    }
    if (this.$route.query.validateCust) {
      this.form.validateCust = this.$route.query.validateCust;
    }
    if (this.$route.query.cusId) {
      this.form.cusId = this.$route.query.cusId;
    }
    if (id) {
      this.form = {
        id: id || "",
        tel: tel || "",
        name: name || "",
        cusBoId: this.form.cusBoId,
        validateCust: this.form.validateCust,
        cusId: this.form.cusId
      };
    }
  },
  methods: {
    onSubmit() {
      const url = this.form.id ? "pickUp/memberselfEdit" : "pickUp/updateSelf";
      this.$store.dispatch(url, this.form).then(res => {
        console.log(res);
        const msg = this.form.id ? "编辑成功！" : "添加成功！";
        if (res.code === "0") {
          Toast.success(msg);
          setTimeout(() => {
            this.$router.push({
              path: `/selfAddr?cusBoId=${this.form.cusBoId}&validateCust=${this.form.validateCust}&cusId=${this.form.cusId}`
            });
          }, 1000);
        } else {
          Toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./add.scss";
</style>
